const header = document.querySelector('header');
const body = document.body;
const stickyThreshold = 80;
let headerIsSticky = false;

function updateHeaderState() {
    const shouldStick = window.scrollY > stickyThreshold;

    if (shouldStick && !headerIsSticky) {
        headerIsSticky = true;
        header.classList.add('is-sticky');
        body.classList.add('has-sticky-header');

        requestAnimationFrame(() => {
            header.classList.add('is-visible');
        });
    } else if (!shouldStick && headerIsSticky) {
        headerIsSticky = false;
        header.classList.remove('is-visible');
        header.classList.remove('is-sticky');
        body.classList.remove('has-sticky-header');
    }
}

function animateCountups() {
    const counters = document.querySelectorAll('.countup');

    counters.forEach((counter, index) => {
        const target = Number(counter.dataset.target || 0);
        const suffix = counter.dataset.suffix || '';
        const duration = (1200 + index * 250) * 1.2;
        const startTime = performance.now();

        function step(currentTime) {
            const progress = Math.min((currentTime - startTime) / duration, 1);
            const eased = 1 - Math.pow(1 - progress, 3);
            const currentValue = Math.round(target * eased);
            counter.textContent = `${currentValue}${suffix}`;

            if (progress < 1) {
                requestAnimationFrame(step);
            } else {
                counter.textContent = `${target}${suffix}`;
            }
        }

        requestAnimationFrame(step);
    });
}

function setupRevealAnimations() {
    const sections = document.querySelectorAll('.reveal-section');

    const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
            if (entry.isIntersecting) {
                entry.target.classList.add('is-visible');
                observer.unobserve(entry.target);
            }
        });
    }, {
        threshold: 0.15
    });

    sections.forEach((section) => observer.observe(section));
}

function initProjectsSlider() {
    const sliderElement = document.querySelector('.g-projects-wrap');

    if (!sliderElement || typeof Swiper === 'undefined') {
        return;
    }

    new Swiper(sliderElement, {
        slidesPerView: 3,
        spaceBetween: 20,
        pagination: {
            el: '.swiper-pagination',
            clickable: true
        },
        breakpoints: {
            0: {
                slidesPerView: 1.2,
                spaceBetween: 16
            },
            768: {
                slidesPerView: 2,
                spaceBetween: 20
            },
            1024: {
                slidesPerView: 3,
                spaceBetween: 20
            }
        }
    });
}

function initVideoPreviewModal() {
    const modal = document.getElementById('videoModal');
    const modalVideo = document.getElementById('videoModalPlayer');
    const buttons = document.querySelectorAll('.video-preview-btn');

    if (!modal || !modalVideo || buttons.length === 0) {
        return;
    }

    const closeModal = () => {
        modal.classList.remove('is-open');
        modal.setAttribute('aria-hidden', 'true');
        modalVideo.pause();
        modalVideo.currentTime = 0;
    };

    buttons.forEach((button) => {
        button.addEventListener('click', (e) => {
            e.preventDefault();
            const videoSrc = button.dataset.video;
            const posterSrc = button.dataset.poster;

            if (videoSrc) {
                modalVideo.src = videoSrc;
                modalVideo.poster = posterSrc || '';
                modalVideo.load();
                modal.classList.add('is-open');
                modal.setAttribute('aria-hidden', 'false');
                modalVideo.play().catch(() => {});
            }
        });
    });

    document.querySelectorAll('[data-close-modal]').forEach((element) => {
        element.addEventListener('click', closeModal);
    });

    document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') {
            closeModal();
        }
    });
}

window.addEventListener('scroll', updateHeaderState, { passive: true });
window.addEventListener('load', () => {
    updateHeaderState();
    animateCountups();
    //setupRevealAnimations();
    initProjectsSlider();
    initVideoPreviewModal();
});
